import type { HelpLauncherItem } from '@features/help-launcher/types'
import { isHelpLauncherHiddenPath } from '@features/help-launcher/visibility'
import { Sparkles } from 'lucide-react'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import type { InvoiceWhatsNewController } from './WhatsNewContext'

export const useWhatsNewLauncherItem = (
  controller: InvoiceWhatsNewController | null,
): HelpLauncherItem => {
  const { pathname } = useLocation()

  return useMemo(
    () => ({
      id: 'whats-new',
      label: "What's New",
      prefix: <Sparkles size={18} strokeWidth={1.9} />,
      onAction: () => {
        controller?.openListModal()
      },
      hidden: !controller?.enabled || isHelpLauncherHiddenPath(pathname),
      order: 15,
    }),
    [controller, pathname],
  )
}
